import { render } from "./LocationDetailsForm.vue?vue&type=template&id=6290cf3c"
import script from "./LocationDetailsForm.vue?vue&type=script&lang=js"
export * from "./LocationDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__